import { userRightsRequest } from '@/network/requests/userRights'
import { user_rights } from '@/interfaces/user_rights'
import { userRightsGroupRequest } from '@/network/requests/userRightsGroup'

/**
 * 获取所有的菜单（用户权限）
 */
var getUserRights = () => {
	return userRightsRequest.queryAll()
}

/**
 * 获取菜单树。
 */
var getMenuTree = async () => {
	var userRights = await getUserRights()

	//先对菜单进行排序
	userRights.sort((x, y) => {
		if (x.sort < y.sort) {
			return -1
		} else if (x.sort > y.sort) {
			return 1
		} else {
			return 0
		}
	})

	userRights.forEach(item => {
		//删除所有children,以防止多次调用
		delete item.children
	})

	var map = {} // 将数据存储为以id为 KEY的 map索引数据列
	userRights.forEach(item => {
		map[item._id?.$oid!] = item
	})

	console.log('map', map)
	var val: any = []
	userRights.forEach(item => {
		var parent = map[item.parent]
		if (parent) {
			//如果找到索引，说明此项不在顶级当中,那么需要把此项添加到，他对应的父级中
			if (!parent.children) {
				parent.children = []
			}
			parent.children.push({
				id: item._id?.$oid,
				label: item.name,
				route: item.router,
			})
		} else {
			//默认显示
			val.push({
				id: item._id?.$oid,
				label: item.name,
				route: item.router ?? '',
				icon: item.icon,
				index: item.sort.toString(),
				children: item.children,
				display: true,
			})
		}
	})

	return val
}

/**
 * 保存菜单。
 * @param userRights
 */
var saveMenuItem = (userRights: user_rights) => {
	if (userRights._id) {
		return userRightsRequest.modifyById(userRights._id.$oid, userRights)
	} else {
		return userRightsRequest.upload(userRights)
	}
}

/**
 * 删除菜单。
 * @param right_id
 */
var deleteMenu = (right_id: string) => {
	return userRightsRequest.deleteById(right_id)
}

export default {
	saveMenuItem,
	getUserRights,
	getMenuTree,
	deleteMenu,
}
